import React from "react";
import NovoBoleto from "../../../components/acesso-rapido/boleto/novo-boleto/index";

export default function () {
  return <NovoBoleto />;
}
